import React, { useState } from "react";
import DomainSeoHelmet from "../agentic/DomainSeoHelmet";
import DomainHiddenSeoContent from "../agentic/DomainHiddenSeoContent";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "../agentic/domainUseCaseLayout";
import UseCaseIndexGrid from "../agentic/UseCaseIndexGrid";
import RpaProcessFlow from "./RpaProcessFlow";
import {
  INSURANCE_DOMAIN_INTRO,
  INSURANCE_GROUPS,
  INSURANCE_USE_CASES_SEO,
  INSURANCE_DOMAIN_FAQS,
  INSURANCE_ITEM_LIST_JSONLD,
  INSURANCE_BREADCRUMB_JSONLD,
  INSURANCE_WEBPAGE_JSONLD,
  INSURANCE_FAQ_JSONLD,
} from "../../data/rpa/insurance-domainUseCases";

function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<RpaProcessFlow useCase={useCase} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = INSURANCE_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;
  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">
        {cases.map((uc) => (
          <UseCaseCard key={uc.id} useCase={uc} />
        ))}
      </div>
    </section>
  );
}

export default function InsuranceRpaDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");
  const visibleGroups =
    activeFilter === "all"
      ? INSURANCE_GROUPS
      : INSURANCE_GROUPS.filter((group) => group.id === activeFilter);

  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={INSURANCE_DOMAIN_INTRO}
        domainSlug="insurance-domain"
        basePath="/rpa-use-cases"
        useCaseCount={INSURANCE_USE_CASES_SEO.length}
        groupCount={INSURANCE_GROUPS.length}
        itemListJsonLd={INSURANCE_ITEM_LIST_JSONLD}
        faqJsonLd={INSURANCE_FAQ_JSONLD}
        breadcrumbJsonLd={INSURANCE_BREADCRUMB_JSONLD}
        webPageJsonLd={INSURANCE_WEBPAGE_JSONLD}
        keywords="Insurance automation, document AI + RPA, workflow automation, robotic process automation India UAE KSA UK USA"
        sectionLabel=""
      />
      <style>{DOMAIN_PAGE_STYLES}</style>
      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{INSURANCE_DOMAIN_INTRO.title}</h1>
          {INSURANCE_DOMAIN_INTRO.content ? <p>{INSURANCE_DOMAIN_INTRO.content}</p> : null}
        </div>
      </header>
      <UseCaseIndexGrid
        useCases={INSURANCE_USE_CASES_SEO}
        groups={INSURANCE_GROUPS}
        heading="Insurance Use Cases"
        onFilterChange={setActiveFilter}
      />
      <div className="fin-wrap">
        {visibleGroups.map((group) => (
          <GroupSection key={group.id} group={group} />
        ))}
      </div>
      <DomainHiddenSeoContent
        domainTitle={INSURANCE_DOMAIN_INTRO.title}
        domainFaqs={INSURANCE_DOMAIN_FAQS}
        useCases={INSURANCE_USE_CASES_SEO}
      />
    </div>
  );
}

